import React, { useState, useEffect, useCallback } from 'react';
import DetailedPageLayout from '../components/DetailedPageLayout';
import CustomAreaChart from '../../../components/Charts/CustomAreaChart';
import CustomDonutChart from '../../../components/Charts/CustomDonutChart';
import StatCard from '../components/ui/StatCard';
import SectionCard from '../components/ui/SectionCard';
import dashboardAPI from '../../../services/dashboardService';
import { Users, FileText, Calendar, Activity } from 'lucide-react';

const DetailedOverviewPage = ({ isSubView = false, filters: externalFilters, onFilterChange: externalOnFilterChange }) => {
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);
    const [localFilters, setLocalFilters] = useState({ timeRange: '30days', category: 'all' });

    const filters = externalFilters || localFilters;

    const fetchStats = useCallback(async (newFilters = filters) => {
        setLoading(true);
        try {
            const response = await dashboardAPI.getOverviewStats(newFilters);
            setStats(response.data);
        } catch (error) {
            console.error('Failed to fetch overview stats', error);
        } finally {
            setLoading(false);
        }
    }, [filters]);

    const onFilterChange = externalOnFilterChange || ((newFilters) => {
        setLocalFilters(newFilters);
        fetchStats(newFilters);
    });

    useEffect(() => {
        fetchStats(filters);
    }, [fetchStats, filters]);

    if (loading || !stats) {
        return <div className="sd-loading-message">Loading statistics...</div>;
    }

    const deviceData = stats.graph_data?.device_stats || [];
    const growthData = stats.graph_data?.visitor_growth || [];

    return (
        <DetailedPageLayout
            title="System Overview"
            onFilterChange={onFilterChange}
            filters={filters}
            isSubView={isSubView}
        >
            <div className="sd-grid sd-grid--kpi-primary">
                <StatCard label="Total Users" value={stats.totalUsers} icon={Users} color="bg-blue-500" />
                <StatCard label="Total Posts" value={stats.totalPosts} icon={FileText} color="bg-violet-500" />
                <StatCard label="Appointments" value={stats.totalAppointments} icon={Calendar} color="bg-rose-500" />
                <StatCard label="Active Clinics" value={stats.activeClinics} icon={Activity} color="bg-teal-500" />
            </div>

            <div className="sd-grid sd-grid--charts sd-grid--last">
                <SectionCard title="Visitor Growth" className="sd-card--wide">
                    <CustomAreaChart data={growthData} color="#3b82f6" title="" />
                </SectionCard>
                <SectionCard title="Device Usage">
                    <CustomDonutChart
                        data={deviceData}
                        totalValue={deviceData.reduce((a, b) => a + b.value, 0)}
                        title=""
                    />
                </SectionCard>
            </div>
        </DetailedPageLayout>
    );
};

export default DetailedOverviewPage;
